import React, { useEffect } from 'react';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { BasicContent } from '../components';
import { Loading, Paginate } from '~/components';
import {
  loadTipoUsers,
  removerTipoUser
} from '~/store/modules/tipo_user/action';
import Create from '../Create';
import Edit from '../Edit';

const List = () => {
  let location = useLocation();
  let modal = location.state && location.state.modal;
  const dispatch = useDispatch();
  const { tipo_users, meta } = useSelector(
    ({ TipoUserReducer }) => TipoUserReducer
  );

  
  useEffect(() => {
    dispatch(loadTipoUsers());
  }, [dispatch]);

  const breadcrumb = {
    label: 'Lista',
    to: '/tipo_user',
    active: false,
  };

  const handleRemove = async (event) => {
    const id = event.target.value;
    Swal.fire({
      title: 'Remover?',
      text: 'Deseja Remover esse item?!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim!',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        try {
          await dispatch(removerTipoUser(id));
          await Swal.fire('Sucesso',
            'Removido com sucesso!',
            'success');
          dispatch(loadTipoUsers());
        } catch (error) {
          await Swal.fire('Erro',
            'Erro ao Remover',
            'error');
        }
      }
    })
  };
  return (
    <>
      {modal && (
        <Switch>
          <Route
            children={<Create />}
            path="/tipo_user/create"
          />
          <Route
            children={<Edit />}
            exact
            path="/tipo_user/:tipo_user_id/edit"
          />
        </Switch>
      )}
      <BasicContent breadcrumb={breadcrumb}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Lista</h2>

            <div className="card-tools">
              <Link
                className="btn btn-success"
                to={{
                  pathname: '/tipo_user/create',
                  state: { modal: true },
                }}
              >
                <i className="fa fa-plus" /> Novo
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th className="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {tipo_users.data &&
                    tipo_users.data.map((tipo_user, index) => (
                      <tr key={index}>
                        <td>{tipo_user.id}</td>
                        <td>{tipo_user.nome}</td>
                        <td>
                          <div className="btn-group float-right">
                            <a
                              className="btn btn-info"
                              href={`/tipo_user/${tipo_user.id}/detalhe`}
                            >
                              <FaEye /> Detalhes
                            </a>
                            <Link
                              className="btn btn-default"
                              to={{
                                pathname: `/tipo_user/${tipo_user.id}/edit`,
                                state: { modal: true },
                              }}
                            >
                              <FaEdit /> Editar
                            </Link>
                            <button
                              className="btn btn-danger"
                              onClick={handleRemove}
                              value={tipo_user.id}
                            >
                              <FaTrash /> Remover
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!tipo_users.data && <Loading />}
            </div>
          </div>
          <div className="card-footer clearfix">
            <Paginate
              load={loadTipoUsers}
              meta={meta}
            />
          </div>
        </div>
      </BasicContent>
    </>
  );
};

export default List;
